import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ProductoService } from '../../producto/producto.service';
import { TipoActualizacionService } from '../../tipo-actualizacion/tipo-actualizacion.service';
import { ActualizacionStockService } from '../actualizacion-stock.service';
import { TipoActualizacionCreateComponent } from '../../tipo-actualizacion/tipo-actualizacion-create/tipo-actualizacion-create.component';

@Component({
  selector: 'app-actualizacion-stock-create',
  templateUrl: './actualizacion-stock-create.component.html',
  styles: [
  ]
})
export class ActualizacionStockCreateComponent implements OnInit {

  form: FormGroup = new FormGroup({});
  form_producto: FormGroup = new FormGroup({});

  productos: any[] = [];
  tipo_actulizaciones: any[] = []

  linea: any[] = []

  acciones = [
    {
      icon: "trash",
      name: "Eliminar",
      action: (element: any, index: number) => {
        this.eliminarLinea(index);
      }
    }
  ]

  columnas = [
    {
      label: 'Producto',
      value: (element: any) => {
        return element.nombre;
      },
      responsive: ['XS', 'SM', 'MD']
    },
    {
      label: 'Cantidad',
      value: (element: any) => {
        return this.formatter.numberFormat(element.cantidad);
      },
      responsive: ['XS', 'SM', 'MD']
    },
  ]

  constructor(
    public formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    public service: ActualizacionStockService,
    private productoService: ProductoService,
    private tipoActualizacionService: TipoActualizacionService,
    private loading: LoadingService,
    private alerts: AlertService,
    public formatter: FormatterService,
    private modalService: NgbModal
  ) { 
    this.loadProductos()
    this.loadTipoActualizacion()
  }

  ngOnInit(): void {
    const fecha = new Date().toISOString().slice(0,10);

    this.form = this.formBuilder.group({
      tipo_actualizacion_id: [null, [Validators.required]],
      fecha: [fecha, [Validators.required]],
      detalle: [null]
    });

    this.form_producto = this.formBuilder.group({
      producto_id: [null, [Validators.required]],
      cantidad: [1, [Validators.required]]
    });
  }

  agregarTipo(){
    const modalRef = this.modalService.open(TipoActualizacionCreateComponent,{ size: 'lg', scrollable: true });
    modalRef.result.then((result: any) => {
      this.loadTipoActualizacion(true);
    }, (reason: any) => {});
  }

  loadProductos(): void {
    this.loading.show();
    this.productoService.select().subscribe ({
      next: (res: any[]) => {
        if (res.length === 0) {
          this.loading.hide();
          this.alerts.addAlert("No hay productos registrados.", "info");
        } else {
          this.loading.hide();
          this.productos = res.filter(e => e.tipo == 1);
        }
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo cargar la lista de productos.", "danger");
      }
    });
  }

  loadTipoActualizacion(setLastElement: boolean = false): void {
    this.loading.show();
    this.tipoActualizacionService.select().subscribe ({
      next: (res: any[]) => {
        this.loading.hide();
        this.tipo_actulizaciones = res;
        if (setLastElement && this.tipo_actulizaciones.length) this.form.patchValue({ tipo_actualizacion_id: this.tipo_actulizaciones[this.tipo_actulizaciones.length -1].id })
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo cargar la lista de tipo de actualizaciones.", "danger");
      }
    });
  }

  agregar(): void {
    if (this.form_producto.valid) {

      const index_linea: number = this.linea.findIndex((x: any) => x.producto_id === this.form_producto.controls['producto_id'].value)
      const index_producto: number = this.productos.findIndex(x => x.id === this.form_producto.controls['producto_id'].value);

      if (index_linea == -1) {
        let aux = this.linea.slice(0);
        aux.push({
          nombre: this.productos[index_producto].nombre,
          cantidad: this.form_producto.controls['cantidad'].value,
          producto_id: this.form_producto.get('producto_id')?.value
        })
        this.linea = aux
      } else {
        this.alerts.addAlert("El producto " + this.productos[index_producto].nombre + " ya está agregado.", "warning");
      }
      this.form_producto.controls['producto_id'].setValue(null);
      this.form_producto.controls['cantidad'].setValue(1);
      this.form_producto.controls['producto_id'].markAsUntouched();
      this.form_producto.controls['cantidad'].markAsUntouched();

    } else {
      this.form_producto.markAllAsTouched();
      this.alerts.addAlert("Hay errores en el formulario.", "warning");
    }
  }

  registrar(): void {
    if (!this.form.valid ) {
      this.form.markAllAsTouched();
      this.alerts.addAlert("Hay errores en el formulario.", "warning");
      return;
    }

    if (this.linea.length === 0) {
      this.alerts.addAlert("No hay productos seleccionados.", "warning");
      return
    }

    let actualizacion: any = this.form.value;

    actualizacion.fecha = actualizacion.fecha.replace(/-/g, '\/');

    actualizacion.linea_actualizacion = this.linea.map(({ producto_id, cantidad }) => ({ producto_id, cantidad }));

    this.loading.show();

    this.service.insert(actualizacion).subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.activeModal.close(res.model);
        this.alerts.addAlert("Registro de Actualización de Stock generado con éxito.", "success");
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo guardar el Registro de Actualización de Stock.", "danger");
        if (err.error.msg) {
          this.alerts.addAlert(err.error.msg, "danger");
        }
        if (err.error.errors[0]) {
          this.alerts.addAlert(err.error.errors[0].msg, "danger");
        }
      },
    })

  }

  eliminarLinea(index: number): void {
    if (this.linea.length === 1) {
      let aux: any[] = []
      this.linea = aux;
    } else {
      let aux = this.linea.splice(index, 1)
      this.linea = aux;
    }
  }

}
